export type AiTextModelTier = 'fast' | 'balanced' | 'premium' | 'reasoning';

export interface AiTextModelInfo {
  id: string;
  label: string;
  tier: AiTextModelTier;
  cost: string;
  bestFor: string;
}

export function openAiModelUsesDefaultTemperature(modelId: string): boolean {
  return /^(?:gpt-5(?:[.-]|$)|o[1-9](?:[.-]|$))/i.test(modelId.trim());
}

// Koszt: input / output za 1 mln tokenów według oficjalnego cennika OpenAI.
export const CHATGPT_TEXT_MODELS: AiTextModelInfo[] = [
  {
    id: 'gpt-5.6-sol',
    label: 'GPT-5.6 Sol',
    tier: 'premium',
    cost: '$4 / $20',
    bestFor: 'Najwyższa jakość: strategia, analiza i finalne treści',
  },
  {
    id: 'gpt-5.6-terra',
    label: 'GPT-5.6 Terra',
    tier: 'balanced',
    cost: '$2 / $12',
    bestFor: 'Wysoka jakość i niższy koszt: baza wiedzy, landing, ad copy',
  },
  {
    id: 'gpt-5.6-luna',
    label: 'GPT-5.6 Luna',
    tier: 'fast',
    cost: '$0.20 / $1.20',
    bestFor: 'Masowe lekkie zadania: tagi, proste pola i formatowanie',
  },
];

// Official international API pricing, USD / 1M tokens, verified 2026-09-09.
// https://platform.kimi.ai/
export const KIMI_TEXT_MODELS: AiTextModelInfo[] = [
  { id: 'kimi-k3', label: 'Kimi K3', tier: 'premium', cost: '$3 / $15', bestFor: 'Strategia, analiza obrazów i złożone treści; cache $0.30' },
  { id: 'kimi-k2.6', label: 'Kimi K2.6', tier: 'balanced', cost: '$0.95 / $4', bestFor: 'Treści, klasyfikacja i analiza obrazów; cache $0.16' },
  { id: 'kimi-k2.7-code', label: 'Kimi K2.7 Code', tier: 'reasoning', cost: '$0.95 / $4', bestFor: 'Kod i złożone instrukcje; cache $0.19' },
];
